export default {
    S: 'Sim', N: 'Não'
}
